import { RegistrationTypeController } from './registration-type.controller';

export const RegistrationTypeComponent: ng.IComponentOptions = {
    template: require('./registration-type.html'),
    controller: RegistrationTypeController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/registration-type/registration-type.component.ts